import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginTop: theme.spacing(0.5),
    fontSize: 20,
    color: 'black',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 15,
    width: '27%',
  },
  formControl: {
    width: '100%',
  },
  link: {
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-end',
  },
  margin: {
    margin: theme.spacing(1),
  },
  marginTop: {
    marginTop: theme.spacing(3),
  },
  footnote: {
    opacity: 0.5,
    margin: theme.spacing(1),
  },
  text: {
    textAlign: 'center',
    padding: '8px',
  },
  actionBtn: {
    width: '65%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
  cancelButton: {
    width: '30%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
}));
